export default __webpack_public_path__ + "static/media/loading.a74b50f6.gif";